import { useRef, useState } from 'react'

import Map from './Map'
import ResultsList from './ResultsList'

const SearchResults = ({ searchData, setDealer }) => {
  const [selectedDealerId, setSelectedDealerId] = useState('')
  const scrollRef = useRef(null)

  const handleSelectedDealerId = (dealerId) => {
    if (window.customMap && dealerId) {
      setSelectedDealerId(dealerId)
      window.customMap.clearMarkers()
      const addMarkers = (dealers) => {
        dealers.forEach((d, index) => {
          const markerIndex = index + 1
          const markerOptions = {
            markerAttributes: {
              'data-dealer-id': d.localDealerID,
            },
            fitToBounds: true,
            boundsPreservePaddingLeft: 50,
            boundsPreservePaddingTop: 50,
            boundsPreservePaddingBottom: 50,
            boundsPreservePaddingRight: 50,
            markerImage: `${
              dealerId === d.localDealerID
                ? 'toyota-black-innericon-text-dark'
                : 'toyota-white-innericon-text-dark'
            }`,
            markerClick: (i) => {
              const cardRef = scrollRef.current?.querySelector(
                `[data-card-index="${markerIndex}"]`,
              )
              if (cardRef) {
                cardRef.scrollIntoView({ behavior: 'smooth' })
              }

              const markerDealer =
                document.querySelectorAll('.mapboxgl-marker')[i]?.dataset
                  ?.dealerId

              handleSelectedDealerId(markerDealer, 'markerclick')
            },
          }
          window.customMap.addMarker(d.address.geo, markerOptions)
        })
      }
      if (navigator.permissions) {
        navigator.permissions
          .query({ name: 'geolocation' })
          .then((permissionStatus) => {
            if (permissionStatus.state === 'granted') {
              navigator.geolocation.getCurrentPosition((position) => {
                const currentLocation = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                }
                const currentLocationMarkerOptions = {
                  // element: el,
                  // markerImage: 'toyota-marker',
                  markerClick: () => {
                    window.customMap.focusOn({ coordinates: currentLocation })
                  },
                }
                window.customMap.addMarker(
                  currentLocation,
                  currentLocationMarkerOptions,
                )
              })
            }
          })
      }
      addMarkers(searchData)
    }
  }

  return (
    <>
      {/* {searchData && searchData.length > 0 && (
        <h3 className="text-xl m-4">
          <span>Your Results: </span>
          <span>Select your dealer</span>
        </h3>
      )} */}
      <div className="flex flex-col lg:flex-row my-6 gap-6">
        <div className="order-last lg:order-first">
          <ResultsList
            searchData={searchData}
            setDealer={setDealer}
            selectedDealerId={selectedDealerId}
            onSelectDealerID={(id) => handleSelectedDealerId(id)}
            scrollRef={scrollRef}
          />
        </div>
        <Map
          searchData={searchData}
          scrollRef={scrollRef}
          triggerMarkers={(id) => handleSelectedDealerId(id)}
        />
      </div>
    </>
  )
}

export default SearchResults
